<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title">
        <span class="fonints">计划单号</span>
        <input
          class="inputs"
          type="text"
          placeholder="输入计划单号"
          v-model.trim="selectitem.pno"
        />
        <span class="fonints">车牌号码</span>
        <input
          class="inputs"
          type="text"
          placeholder="输入车牌号码"
          v-model.trim="selectitem.plate"
        />
        <span class="fonints">申请时间</span>
        <el-date-picker
          v-model="datamsg1"
          @change="dataChange($event, ['applyStartTime', 'applyEndTime'])"
          type="datetimerange"
          range-separator="至"
          value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          :default-time="['00:00:00', '00:00:00']"
        >
        </el-date-picker>
      </div>
      <div class="componentSty_content_title">
        <span class="fonints">审核时间</span>
        <el-date-picker
          v-model="datamsg2"
          @change="dataChange($event, ['auditStartTime', 'auditEndTime'])"
          type="datetimerange"
          range-separator="至"
          value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          :default-time="['00:00:00', '00:00:00']"
        >
        </el-date-picker>
        <div class="cheboxSty">
          <el-radio v-model="selectitem.status" label="1">待退款</el-radio>
          <el-radio v-model="selectitem.status" label="2">已退款</el-radio>
        </div>
        <button class="buttons" @click="selectlist">查询</button>
        <button
          class="buttons"
          @click="cleartiaojian"
          style="background: #ff5926"
        >
          清空
        </button>
      </div>
      <div class="componentSty_content_title">
        <button
          class="buttons"
          style="background: #13d168"
          @click="approved(true)"
        >
          审核通过
        </button>
        <button class="buttons" @click="printList">导出Excel</button>
      </div>
      <div class="componentSty_content_table"   style="top: 135px;border: none;">
        <el-table
          :data="arrlist.list"
          height="80%"
          border
          style="width: 100%;"
          @sort-change="sortchange"
          @selection-change="selChange"
        >
          <el-table-column show-overflow-tooltip v-if="status2 == '1'" type="selection">
          </el-table-column>
          <el-table-column show-overflow-tooltip
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <el-table-column show-overflow-tooltip prop="pno" label="计划单号"></el-table-column>
          <el-table-column show-overflow-tooltip prop="plate" label="车牌号码"> </el-table-column>
          <el-table-column show-overflow-tooltip prop="custmername" label="流向"> </el-table-column>
          <el-table-column show-overflow-tooltip prop="fleetname" label="代理名称"> </el-table-column>
          <el-table-column show-overflow-tooltip prop="refundCause" label="退款原因">
          </el-table-column>
          <el-table-column show-overflow-tooltip label="申请时间">
            <template v-slot="res">
              {{ mydateFormat(res.row.gmtCreate, "时分秒") }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="确认时间">
            <template v-slot="res">
              {{ mydateFormat(res.row.auditDate, "时分秒") }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="peopleAudit" label="操作人"> </el-table-column>
          <el-table-column show-overflow-tooltip label="状态">
            <template v-slot="res">
              <span
                style="color: #ef6b60"
                class="el_spanfontstyle"
                v-if="res.row.status == 1"
                >待退款</span
              >
              <span
                style="color: #ffa500"
                class="el_spanfontstyle"
                v-if="res.row.status == 2"
                >退款成功</span
              >
            </template>
          </el-table-column>
        </el-table>

        <div class="paginations" v-show="arrlist.list && arrlist.list.length">
          <el-pagination
            @size-change="handleSizeChange"
            :page-size="selectitem.limit"
            layout="total,sizes,prev, pager,next, jumper"
            :total="arrlist.totalCount"
            :page-sizes="[20, 50, 100, 200]"
            :current-page="selectitem.page"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import { antiShake, printExcel } from "@/plugins/other.js";
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      listitem: [{ name: "财务管理" }, { name: "退款确认" }],
      selectinfo: "全部",
      datamsg1: [],
      datamsg2: [],
      selectitem: {},
      status2: "1",
      arrlist: {},
      ids: [],
      plate: [],
    };
  },
  computed: {
    ...mapState(["conditionsList"]),
  },
  created() {
    this.conditionsList[this.$route.path] ||
      this.createConditions({
        key: this.$route.path,
        val: {
          page: 1,
          limit: 20,
          status: "1",
        },
      });
    this.selectitem = this.conditionsList[this.$route.path] || {
      page: 1,
      limit: 20,
      status: "1",
    };
    this.datamsg1 = [
      this.selectitem.applyStartTime || "",
      this.selectitem.applyEndTime || "",
    ];
    this.datamsg2 = [
      this.selectitem.auditStartTime || "",
      this.selectitem.auditEndTime || "",
    ];
    this.getarrlist();
  },
  components: {
    mTitle,
  },
  methods: {
    ...mapMutations(["createConditions"]),
    async getarrlist(num) {
      num && (this.selectitem.page = num);
      const { data } = await this.$http(
        "api1",
        "/driver/dispatchtruckrefund/list",
        "get",
        this.selectitem
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.arrlist = data.data;
      this.status2 = this.selectitem.status;
    },
    cleartiaojian() {
      antiShake((_) => {
        this.datamsg1 = [];
        this.datamsg2 = [];
        this.selectitem.status = "1";
        this.selectitem.pno = null;
        this.selectitem.plate = null;
        this.selectitem.applyStartTime = null;
        this.selectitem.applyEndTime = null;
        this.selectitem.auditStartTime = null;
        this.selectitem.auditEndTime = null;
      });
    },
    dataChange(val, arr) {
      val = val || [];
      this.selectitem[arr[0]] = val[0];
      this.selectitem[arr[1]] = val[1];
    },
    printList() {
      printExcel.call(
        this,
        "/driver/dispatchtruckrefund/exportList",
        "退款确认",
        this.selectitem
      );
    },
    selectlist() {
      antiShake((_) => {
        this.selectitem.page = 1;
        this.getarrlist();
      });
    },
    sortchange(event) {
      if (event.order == "ascending") {
        this.selectitem.sidx = event.prop;
        this.selectitem.order = "asc";
      } else if (event.order == "descending") {
        this.selectitem.sidx = event.prop;
        this.selectitem.order = "desc";
      } else {
        this.selectitem.sidx = "";
        this.selectitem.order = "";
      }
      this.getarrlist();
    },
    selChange(event) {
      this.ids = [];
      this.plate = [];
      event.forEach((item) => {
        this.plate.push(item.plate);
        this.ids.push(item.id);
      });
    },
    handleCurrentChange(index) {
      if (this.arrlist.count < this.selectitem.limit) return;
      this.selectitem.page = index;
      this.getarrlist();
    },
    // 切换每页多少条
    handleSizeChange(val) {
      this.selectitem.limit = val;
      this.getarrlist();
    },
    approved(info) {
      if (!this.ids.length) return;
      var path = "",
        successifo = "";
      if (info) {
        path = "/driver/dispatchtruckrefund/refundExaminationPassed";
        successifo = "审核已通过";
      } else {
        // title = "选中的数据将审核不通过";
        // path = "/driver/dispatchtruck/FailedAuditSendSomeonePlan";
        // successifo = "操作成功";
      }
      this.$messageBox
        .confirm(`${this.plate + ""}, 是否继续?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          const { data } = await this.$http("api1", path, "post", {
            ids: this.ids,
          });
          if (data.code != 0) return this.$message.error(data.msg);
          this.$message.success(successifo);
          this.selectitem.page = 1;
          this.getarrlist();
        })
        .catch((err) => err);
    },
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>